import type { MobData } from './types'

// Module-level reference so the mount system can access mobs without prop drilling
let _allMobs: MobData[] = []

export function setAllMobs(mobs: MobData[]) {
  _allMobs = mobs
}

export function getAllMobs(): MobData[] {
  return _allMobs
}
